const CriaArquivo = (bytes, nome) => {
    return new File([bytes], nome, { type: 'image/png', lastModified: new Date() });
}

const TransformaArquivoEmByte = (file) => {
    return new Promise((resolve, reject) => {
        const fileByteArray = [];
        const reader = new FileReader();
    
        reader.onloadend = (evt) => {
            if (evt.target.readyState === FileReader.DONE) {
                const arrayBuffer = evt.target.result,
                    array = new Uint8Array(arrayBuffer);
    
                for (const a of array) {
                    fileByteArray.push(a);
                }

                resolve(fileByteArray);
            }
        }
    
        reader.onerror = reject;

        reader.readAsArrayBuffer(file);

        
    })
}

export { CriaArquivo, TransformaArquivoEmByte };